import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { planFragment } from "@zapier/upsells/esm/fragments";
import { useCurrentAccountId } from "@zapier/upsells/esm/hooks";
export const planStacksQuery = gql `
  query upsells_planStacksQuery($accountId: Int) {
    planStacks: pricingPageV3Plans(accountId: $accountId) {
      id
      plans {
        ...upsells_planFragment
      }
      planType
    }
  }
  ${planFragment}
`;
export const usePlanStacks = (props = {}) => {
    var _a;
    const useQuery = (props === null || props === void 0 ? void 0 : props.useQuery) || defaultUseQuery;
    const { accountId, isLoading: isLoadingCurrentAccountId } = useCurrentAccountId({ useQuery });
    const { data, error, loading: isLoadingPlanStacks, } = useQuery(planStacksQuery, {
        skip: props.skip || isLoadingCurrentAccountId,
        variables: {
            accountId,
        },
    });
    return {
        error: error === null || error === void 0 ? void 0 : error.message,
        isLoading: isLoadingCurrentAccountId || isLoadingPlanStacks,
        planStacks: (_a = data === null || data === void 0 ? void 0 : data.planStacks) !== null && _a !== void 0 ? _a : [],
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
